import React, { useEffect, useState } from "react";
import CoreModal from "../../../../../app/core/components/CoreModal/CoreModal";

import CheckBoxRoundedIcon from "@mui/icons-material/CheckBoxRounded";
import CheckBoxOutlineBlankRoundedIcon from "@mui/icons-material/CheckBoxOutlineBlankRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetSingleDocumentIdQuery } from "../../../../api/admin/gestisciDocumentiApi";
import { TABLE_ROWS_NUMBER } from "../../../../../utils/constants/tables";
import {
  Divider,
  IconButton,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { t } from "i18next";
import { formattaData } from "../../../../../utils/functions/date-utils";
import CoreSpinner from "../../../../../app/core/components/CoreSpinner/CoreSpinner";
import CorePagination from "../../../../../app/core/components/CorePagination/CorePagination";
import SingleDocumentPage from "../../../../common/SingleDocumentPage/SingleDocumentPage";
import { toast } from "react-toastify";
import {
  useDoAddDocumentFolderMutation,
  useDoDeleteDocumentFolderMutation,
  useGetAllUserDocumentsFolderQuery,
} from "../../../../api/admin/adminFolders";
import CoreSearchBar from "../../../../../app/core/components/CoreSearch/CoreSearch";
import FolderDocumentFilter from "./FolderDocumentFilter";
import CoreChip from "../../../../../app/core/components/CoreChip/CoreChip";
import { labelForFilterDoc } from "../../../../../utils/functions/filters";
import { useSelector } from "react-redux";
import CoreBack from "../../../../../app/core/components/CoreBack/CoreBack";

const DocumentiUserPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const categories = useSelector((state) => state.categories.macroCategories);

  const searchParams = new URLSearchParams(location.search);
  const categoriaParam = searchParams.get("categoria");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [listIdDocs, setListIdDocs] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [filter, setFilter] = useState({
    mainCategoryId: "",
    categoryId: categoriaParam || "",
  });
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });

  const { data: singleDoc, isLoading: loadingSingleDoc } =
    useGetSingleDocumentIdQuery(selectedDoc, {
      skip: !selectedDoc,
    });

  const { data: documentsData, isLoading: loadingDocuments } =
    useGetAllUserDocumentsFolderQuery(
      {
        page,
        folderId: location.state.folderId,
        filter: {
          ...filter,
        },
        orderDirection: "desc",
        valueToOrderBy: "createdAt",
        query: debouncedSearchTerm,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (documentsData) {
      setListIdDocs(documentsData.Data.items.map((el) => el.id));
    }
  }, [documentsData]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 750);
    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm]);

  const [addDocumentFolder] = useDoAddDocumentFolderMutation();
  const [deleteDocumentFolder] = useDoDeleteDocumentFolderMutation();

  const openModal = (doc) => {
    setSelectedDoc(doc);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleAddDocument = (docId) => {
    const body = {
      folderId: location.state.folderId,
      documentId: docId,
    };
    addDocumentFolder(body).then((res) => {
      if (res?.data?.Result !== 1) {
        toast.error(res?.error?.message);
      } else {
        toast.success(t("DocAdded"));
      }
    });
  };

  const handleDocumentDelete = (docId) => {
    const params = {
      folderId: location.state.folderId,
      documentId: docId,
    };
    deleteDocumentFolder(params).then((res) => {
      if (res?.data?.Result !== 1) {
        toast.error(res?.error?.message);
      } else {
        toast.success(t("DocRemoved"));
      }
    });
  };

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) newFilter[k] = "";
    });
    setFilter(newFilter);
  };

  if (loadingDocuments || loadingSingleDoc) {
    return <CoreSpinner />;
  }

  return (
    <div className="p-4">
      <div className="flex justify-center w-full mb-4 items-center">
        <CoreBack />
        <div className="w-11/12 flex items-center justify-between">
          <h2 className="fw-bold">{location.state.user.name}</h2>
        </div>
      </div>
      <div className="w-1/3">
        <CoreSearchBar
          isLoading={loadingDocuments}
          placeholder={t("Search") + " " + t("document")}
          searchTerm={searchTerm}
          handleChange={setSearchTerm}
        />
      </div>
      <div className="flex flex-row -mt-16 justify-end space-x-2">
        {Object.entries(filter).map(
          ([k, v]) =>
            v !== "" && (
              <CoreChip
                key={v}
                label={labelForFilterDoc(k, v, categories)}
                variant="outlined"
                onDelete={() => handleRemoveFilter(v)}
              />
            )
        )}
        <FolderDocumentFilter
          filter={filter}
          setFilter={setFilter}
          setPage={setPage}
        />
        {/* FIlter component */}
      </div>
      <div className="w-full mt-10">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t("Name")}</TableCell>
                <TableCell>{t("Date")}</TableCell>
                <TableCell>{t("Uploaded")}</TableCell>
                <TableCell>{t("Amount")}</TableCell>
                <TableCell>{t("Category")}</TableCell>
                <TableCell>{t("Actions")}</TableCell>
              </TableRow>
            </TableHead>
            {documentsData?.Data?.items?.map((documento) => (
              <TableRow className="hover:shadow-md" key={documento.id}>
                <TableCell>{documento.name}</TableCell>
                <TableCell>{formattaData(documento.date)}</TableCell>
                <TableCell>{formattaData(documento.createdAt)}</TableCell>
                <TableCell>{documento.amount}</TableCell>
                <TableCell>{documento.categoryName}</TableCell>
                <TableCell>
                  <Tooltip title="Dettaglio">
                    <IconButton
                      onClick={() => openModal(documento.id)}
                      className="w-10 h-10"
                    >
                      <SearchRoundedIcon />
                    </IconButton>
                  </Tooltip>
                  {documento.boundedWithFolder ? (
                    <Tooltip title={"Removi dalla " + t("Folder")}>
                      <IconButton
                        onClick={() => handleDocumentDelete(documento.id)}
                        className="w-10 h-10 text-blue-600"
                      >
                        <CheckBoxRoundedIcon />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip title={t("Add") + " alla " + t("Folder")}>
                      <IconButton
                        className="w-10 h-10 text-blue-600"
                        onClick={() => handleAddDocument(documento.id)}
                      >
                        <CheckBoxOutlineBlankRoundedIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {documentsData?.Data?.items?.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center text-gray">
                  {t("NoDocs")}
                </TableCell>
              </TableRow>
            )}
          </Table>
        </TableContainer>
        <Divider />
        <div className="w-full flex justify-center">
          <CorePagination
            page={page}
            setPage={setPage}
            totalPages={
              Math.ceil(documentsData?.Data?.count / TABLE_ROWS_NUMBER) || 1
            }
          />
        </div>
      </div>
      <CoreModal
        disableClose={true}
        width={"100%"}
        height={"100%"}
        state={isModalOpen}
        component={
          <SingleDocumentPage
            document={singleDoc?.Data}
            closeModal={closeModal}
            documents={listIdDocs}
            typeButton={t("Edit")}
            onOpenDoc={openModal}
          />
        }
      />
    </div>
  );
};

export default DocumentiUserPage;
